const POS_READER_DIALOG_STATUS = Object.freeze({
  cancel: 'cancel',
  connected: 'connected',
  closed: 'closed',
  disconnected: 'disconnected',
  error: 'error',
  failure: 'failure',
  open: 'open',
  success: 'success',
});

// noinspection JSUnusedGlobalSymbols
export default POS_READER_DIALOG_STATUS;
